import React, { useState } from 'react'
import emailjs from "@emailjs/browser";
import { Link } from 'react-router-dom';



const Contact = () => {

    const [name, setName] = useState("");
    const [mobile, setMobile] = useState("");
    const [mail, setmail] = useState("");
    const [massages, setMassages] = useState("");

    const nameChange = (e) => {
        const value = e.target.value;
        setName(value);
    };
    const mobileChange = (e) => {
        const value = e.target.value;
        setMobile(value);
    };
    const mailChange = (e) => {
        const value = e.target.value;
        setmail(value);
    };
    const massagesChange = (e) => {
        const value = e.target.value;
        setMassages(value);
    };
    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
            .sendForm(
                // "service_zerf1uq",
                // "template_m7f1atf",
                // "#myForm",
                // "X5KUzJh_LXeCzDftt"
            )
            .then(
                function (response) {
                    console.log("SUCCESS!", response.status, response.text);
                    if (response.text === "OK") {
                        setName("");
                        setMobile("");
                        setmail("");
                        setMassages("");
                    }
                },
                function (error) {
                    console.log("FAILED...", error);
                }
            );
    };

    return (
        <>

            <div className="breadcrumb-wrapper bg-cover" style={{ backgroundImage: 'url("assets/img/breadcrumb-bg.png")' }}>
                <div className="sun-shape">
                    <img src="assets/img/sun.png" alt="shape-image" />
                </div>
                <div className="cloud-shape float-bob-x">
                    <img src="assets/img/cloud.png" alt="shape-image" />
                </div>
                <div className="perashute-shape float-bob-y">
                    <img src="assets/img/perasute.png" alt="shape-image" />
                </div>
                <div className="tree-shape">
                    <img src="assets/img/tree.png" alt="shape-image" />
                </div>
                <div className="bottom-shape">
                    <img src="assets/img/breadcrumb-shape.png" alt="img" />
                </div>
                <div className="container">
                    <div className="page-heading">
                        <ul className="breadcrumb-items wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp' }}>
                            <li>
                                <Link to="/">Home</Link>
                            </li>
                            <li> Contact Us</li>
                        </ul>
                        <h1 className="char-animation" style={{ perspective: 300 }}><div style={{ position: 'relative', display: 'inline-block' }}><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>C</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>o</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>n</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>t</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>a</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>c</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>t</div></div> <div style={{ position: 'relative', display: 'inline-block' }}><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>U</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>s</div></div></h1>
                    </div>
                </div>
            </div>

            <section className="contact-section-inner section-padding" style={{ marginTop: "-40px" }}>
                <div className="container">
                    <div className="contact-wrapper mt-0 mb-0 contact-wrapper-two">
                        <div className="row g-4 align-items-center">
                            <div className="col-xl-7 col-lg-6">
                                <div className="contact-from contact-from-two">
                                    <h2 className="text-white mb-3" style={{ textAlign: "" }}>Send Your Message</h2>
                                    <form className="contFrm contFrm-two" id="myForm" onSubmit={sendEmail} action=""
                                        method="post">
                                        <div className="row">
                                            <div className="col-sm-6 wow fadeInRight" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInRight' }}>
                                                <span>Name</span>
                                                <input placeholder="Your Name" className="inptFld"
                                                    name='from_name' type="text" value={name} onChange={(e) => nameChange(e)}
                                                />
                                            </div>
                                            <div className="col-sm-6 wow fadeInLeft" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInLeft' }}>
                                                <span>Your Email</span>
                                                <input placeholder="Email Address" className="inptFld"
                                                    type="email" name="mail" value={mail} onChange={(e) => mailChange(e)}
                                                />
                                            </div>
                                            <div className="col-sm-12 wow fadeInRight" data-wow-delay=".5s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInRight' }}>
                                                <span>Phone</span>
                                                <input name="phone" placeholder="Phone Number" className="inptFld"
                                                    type='number' value={mobile} onChange={(e) => mobileChange(e)}
                                                />
                                            </div>

                                            <div className="col-sm-12 wow fadeInUp" data-wow-delay=".6s" style={{ visibility: 'visible', animationDelay: '0.6s', animationName: 'fadeInUp' }}>
                                                <span>Your message</span>
                                                <textarea className="inptFld inptFld-2 mb-0" name="message" placeholder="Your Message..." defaultValue=""
                                                    type="text" value={massages} onChange={(e) => massagesChange(e)}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                    <div className="contact-button wow fadeInUp" data-wow-delay=".7s" style={{ visibility: 'visible', animationDelay: '0.7s', animationName: 'fadeInUp' }}>
                                        <button type="submit" className="theme-btn">Send Your Message<i className="icon-arrow-icon" /></button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6">
                                <div className="contact-info-items">
                                    <div className="section-title text-center text-lg-start">
                                        <span className="sub-title wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>Get In Touch</span>
                                        <h2 className="char-animation" style={{ perspective: 300 }}> <div style={{ position: 'relative', display: 'inline-block' }}> <div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>C</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>o</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>n</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>t</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>a</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>c</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>t</div></div> <span><div style={{ position: 'relative', display: 'inline-block' }}><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>U</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>s</div></div> <div style={{ position: 'relative', display: 'inline-block' }}><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>F</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>o</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>r</div></div> <div style={{ position: 'relative', display: 'inline-block' }}><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>H</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>e</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>l</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>p</div></div></span>
                                        </h2>
                                    </div>
                                    <div className="contact-info contact-info-two wow fadeInLeft" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInLeft' }}>
                                        <div className="icon">
                                            <img src="assets/img/contact/phone.svg" alt="icon-image" />
                                        </div>
                                        <div className="content">
                                            <span>Call Us</span>
                                            <h3>
                                                <a to="tel:+91 9893806170">+91 9893806170, 7999108631</a>
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="contact-info contact-info-two wow fadeInLeft" data-wow-delay=".5s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInLeft' }}>
                                        <div className="icon">
                                            <img src="assets/img/contact/share.svg" alt="icon-image" />
                                        </div>
                                        <div className="content">
                                            <span>Send Email</span>
                                            <h3>
                                                <a to="mailto:sudarshan312317@gmail.com">sudarshan312317@gmail.com</a>
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="contact-info contact-info-two wow fadeInLeft" data-wow-delay=".7s" style={{ visibility: 'visible', animationDelay: '0.7s', animationName: 'fadeInLeft' }}>
                                        <div className="icon">
                                            <img src="assets/img/contact/location01.svg" alt="icon-image" />
                                        </div>
                                        <div className="content">
                                            <span>Location</span>
                                            <a href='https://share.google/1RRNKqdSKHEhcJsRZ' target="_blank">
                                                <h3>Abdul Kalam Azad Ward No.12,  <br /> Neemi Road, Satna (MP)</h3>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <div className="map-section" style={{ marginTop: "-40px" }}>
                <div className="map-items">
                    <div className="googpemap">
                        <div className="mapouter"><div className="gmap_canvas"><iframe className="gmap_iframe" width="100%" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=1200&height=400&hl=en&q=Sudarshan Public School General education school in Satna, Madhya Pradesh&t=&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://embed-googlemap.com">google maps embed</a></div><style dangerouslySetInnerHTML={{ __html: ".mapouter{position:relative;text-align:right;width:100%;height:400px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:400px;}.gmap_iframe {height:400px!important;}" }} /></div>
                    </div>
                </div>
            </div>





        </>
    )
}

export default Contact